import _ from 'lodash'
import axios from '@/backend'

const defaultState = () => {
  return {
    id: null,
    mailbox_id: null,
    to_email: [],
    cc: [],
    subject: '',
    status: null,
    user: {},
    attachments: [],
    content: '',
    message_id: null
  }
}

const state = {
  messageForm: defaultState(),
  sending: false
}

const getters = {
  messageForm (state) {
    return state.messageForm
  },
  draftForm (state) {
    return _.pick(
      state.messageForm,
      ['content', 'to_email', 'cc', 'subject', 'status', 'attachments', 'mailbox_id']
    )
  },
  messageSending (state) {
    return state.sending
  }
}

const mutations = {

  updateMessageForm (state, params) {
    let form = Object.assign({}, state.messageForm, params)
    _.set(state, 'messageForm', form)
  },

  setDefaultMessageForm (state) {
    _.set(state, 'messageForm', defaultState())
  },

  setSendingStatus (state, status) {
    state.sending = status
  }

}

const actions = {
  sendMessage ({commit, rootState}) {
    let message = Object.assign({}, state.messageForm)
    message.cc = extractEmails(message.cc)
    message.to_email = extractEmails(message.to_email)
    if (message.user) {
      message.user_id = message.user.id
    } else {
      message.user_id = null
    }
    message.message_draft_id = rootState.Draft.draft.id
    delete message.user
    if (message.content.length === 0) {
      throw new Error(`No email content: ${message.content}`)
    }
    message.content += rootState.User.user.messageSignature
    return axios.post('/messages', {message: message}).then(response => {
      commit('setDefaultMessageForm')
      commit('setSendingStatus', false)
      return response
    }, error => {
      commit('setSendingStatus', false)
      console.log(error)
    })
  }
}

const extractEmails = (emails) => {
  return emails.map(email => {
    if (email.value) {
      return email.value
    } else if (email.label) {
      return email.label
    } else {
      return email
    }
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/message_form.js